module.exports = __webpack_public_path__ + "img/PU30M_2.ef5a5187.png";